export default __webpack_public_path__ + "static/small_logo-0a6cd3bd1294e9f1c1fc59261ca690b1.png";